import { useEffect, useState } from 'react'

import { SkillApi, SkillTokenParam } from '../interface'

import { SkillProps } from './Skill'
import { SkillIFrame } from './SkillIFrame'
import { useSkillHandler } from './useSkillHandler'

interface FormSkillProps extends SkillProps {
  token: SkillApi['token']
  tokenParam: SkillTokenParam
}

export function FormSkill({
  customer,
  from,
  id,
  params,
  preview,
  src,
  token: generateToken,
  tokenParam,
}: FormSkillProps) {
  const { $skillRef, height } = useSkillHandler({ id })
  const [token, setToken] = useState('')
  const [contactId, setContactId] = useState('')

  useEffect(() => {
    async function init() {
      const { id: contactId, token } = await generateToken(
        src.replace(/^.*?\/skills\/([^\]/?]+).*?$/, '$1'),
        tokenParam
      )
      setToken(token)
      setContactId(contactId)
    }
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  const handleSkillLoad = () => {
    $skillRef?.current?.contentWindow?.postMessage(
      {
        type: 'init',
        _id: id,
        customer,
        params,
        skillParams: {
          id: contactId,
          token,
          from,
          preview,
        },
      },
      '*'
    )
  }

  if (!token) {
    return null
  }

  return (
    <SkillIFrame
      $skillRef={$skillRef}
      height={height}
      src={src}
      handleSkillLoad={handleSkillLoad}
    />
  )
}
